const STORAGE_KEY = "selectedNavigationContext";

const isBrowser =
    typeof window !== "undefined" &&
    typeof window.localStorage !== "undefined";

const normalizeValue = (value) => (value == null ? null : String(value));

const safeParse = (value) => {
    if (!value) return null;

    try {
        return JSON.parse(value);
    } catch (error) {
        return null;
    }
};

const buildRoleSnapshot = (role) => {
    if (!role) return null;

    return {
        id: role.id ?? null,
        code: role.code ?? null,
        name: role.name ?? null,
        moduleId: role.moduleId ?? null,
        moduleName: role.moduleName ?? null,
    };
};

const buildModuleSnapshot = (module, role) => {
    const source = module || role;
    if (!source) return null;

    return {
        id: source.id ?? source.moduleId ?? null,
        code: source.moduleCode ?? source.code ?? null,
        name: source.name ?? source.moduleName ?? null,
    };
};

export const readNavigationSelection = () => {
    if (!isBrowser) return null;
    return safeParse(window.localStorage.getItem(STORAGE_KEY));
};

export const writeNavigationSelection = (selection) => {
    if (!isBrowser) return;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(selection));
};

export const clearNavigationSelection = () => {
    if (!isBrowser) return;
    window.localStorage.removeItem(STORAGE_KEY);
};

export const saveNavigationSelectionForRole = (role, userId) => {
    const previous = readNavigationSelection() || {};

    writeNavigationSelection({
        ...previous,
        userId: normalizeValue(userId ?? previous.userId),
        role: buildRoleSnapshot(role),
        module: buildModuleSnapshot(null, role) || previous.module || null,
    });
};

export const saveNavigationSelectionForModule = (module, userId) => {
    const previous = readNavigationSelection() || {};

    writeNavigationSelection({
        ...previous,
        userId: normalizeValue(userId ?? previous.userId),
        module: buildModuleSnapshot(module, null),
    });
};
